/* Mobile Footer-Accordion */

document.addEventListener('DOMContentLoaded', () => {
  const headings = document.querySelectorAll('.grid .footer-block__heading');

  const handleCollapse = (heading) => {
    const content = heading.nextElementSibling;

    if (heading.classList.contains('block-collapsed')) {
      heading.classList.remove('block-collapsed');
      heading.setAttribute('aria-expanded', 'true');
      content.style.display = 'block';
    } else {
      heading.classList.add('block-collapsed');
      heading.setAttribute('aria-expanded', 'false');
      content.style.display = 'none';
    }
  };

  headings.forEach((heading, index) => {
    heading.classList.add('block-collapsed');
    heading.setAttribute('role', 'button');
    heading.setAttribute('aria-expanded', 'false');
    heading.setAttribute('tabindex', '0');

    const content = heading.nextElementSibling;
    if (content) {
      content.setAttribute('id', `footer-block-index-${index}`);
      heading.setAttribute('aria-controls', `footer-block-index-${index}`);
    }

    heading.addEventListener('click', () => handleCollapse(heading));

    heading.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        handleCollapse(heading);
      }
    });
  });
});


/* Description code */

document.addEventListener("DOMContentLoaded", function () {
  const text = document.getElementById("descText");
  const btn = document.getElementById("toggleBtn");

  if (!text || !btn) return;
  
  // check agar content 5 lines se zyada hai
  if (text.scrollHeight > text.clientHeight) {
    btn.style.display = "inline-block";
  }

  btn.addEventListener("click", function () {
    if (text.classList.contains("expanded")) {
      text.classList.remove("expanded");
      btn.innerText = "See more";
    } else {
      text.classList.add("expanded");
      btn.innerText = "See less";
    }
  });
});

// Removes the newsletter success state from the URL to prevent the message from showing again after page refresh.

  document.addEventListener("DOMContentLoaded", function () {
    if (window.location.search.includes("customer_posted=true")) {
      // Remove URL parameter after showing message once
      const url = new URL(window.location);
      url.searchParams.delete("customer_posted");
      window.history.replaceState({}, document.title, url.pathname);
    }
  });
  
  /* =========================================
   RBS VETERANS DAY ENTRANCE - 2026
   Enhanced Version
========================================= */

document.addEventListener('DOMContentLoaded', function () {
  if (document.querySelector('.rbs-veterans-scene')) return;

  const scene = document.createElement('div');
  scene.className = 'rbs-veterans-scene';

  const glow = document.createElement('div');
  glow.className = 'rbs-veterans-glow';

  const sweep = document.createElement('div');
  sweep.className = 'rbs-veterans-sweep';

  scene.appendChild(glow);
  scene.appendChild(sweep);

  /* Red, White & Blue Stars */
  const starPositions = [
    { left: '6%',  top: '25%', size: 18, delay: 0.10, color: '#B31942' },
    { left: '14%', top: '58%', size: 13, delay: 0.35, color: '#FFFFFF' },
    { left: '22%', top: '35%', size: 16, delay: 0.20, color: '#0A3161' },
    { left: '31%', top: '72%', size: 12, delay: 0.45, color: '#B31942' },
    { left: '39%', top: '18%', size: 17, delay: 0.25, color: '#FFFFFF' },
    { left: '47%', top: '54%', size: 14, delay: 0.40, color: '#0A3161' },
    { left: '56%', top: '30%', size: 18, delay: 0.18, color: '#B31942' },
    { left: '64%', top: '68%', size: 13, delay: 0.50, color: '#FFFFFF' },
    { left: '72%', top: '22%', size: 16, delay: 0.28, color: '#0A3161' },
    { left: '81%', top: '55%', size: 14, delay: 0.42, color: '#B31942' },
    { left: '90%', top: '30%', size: 18, delay: 0.16, color: '#FFFFFF' },
    { left: '95%', top: '70%', size: 12, delay: 0.48, color: '#0A3161' }
  ];

  starPositions.forEach((item, index) => {
    const star = document.createElement('span');

    star.className = 'rbs-veterans-star';
    star.textContent = '★';

    star.style.left = item.left;
    star.style.top = item.top;
    star.style.fontSize = item.size + 'px';
    star.style.animationDelay = item.delay + 's';
    star.style.color = item.color;

    if (index % 3 === 0) {
      star.style.transform = 'rotate(12deg)';
    }

    scene.appendChild(star);
  });

  /* Rhinestone Sparkles */
  const sparklePositions = [
    { left: '10%', top: '42%', color: '#FFFFFF' },
    { left: '18%', top: '75%', color: '#B31942' },
    { left: '27%', top: '28%', color: '#0A3161' },
    { left: '35%', top: '60%', color: '#FFFFFF' },
    { left: '44%', top: '35%', color: '#B31942' },
    { left: '52%', top: '78%', color: '#0A3161' },
    { left: '60%', top: '45%', color: '#FFFFFF' },
    { left: '69%', top: '25%', color: '#B31942' },
    { left: '77%', top: '68%', color: '#0A3161' },
    { left: '85%', top: '38%', color: '#FFFFFF' },
    { left: '92%', top: '58%', color: '#B31942' }
  ];

  sparklePositions.forEach((item, index) => {
    const spark = document.createElement('span');

    spark.className = 'rbs-veterans-spark';
    spark.textContent = index % 2 === 0 ? '✦' : '✧';

    spark.style.left = item.left;
    spark.style.top = item.top;
    spark.style.color = item.color;
    spark.style.fontSize = (8 + (index % 4) * 2) + 'px';
    spark.style.animationDelay = (0.18 + index * 0.07) + 's';

    scene.appendChild(spark);
  });

  /* Extra soft patriotic dots */
  const dotPositions = [
    ['12%', '18%', '#B31942'],
    ['25%', '48%', '#FFFFFF'],
    ['41%', '82%', '#0A3161'],
    ['58%', '16%', '#FFFFFF'],
    ['70%', '50%', '#B31942'],
    ['84%', '78%', '#0A3161'],
    ['93%', '20%', '#FFFFFF']
  ];

  dotPositions.forEach((item, index) => {
    const dot = document.createElement('span');
    dot.className = 'rbs-veterans-spark';
    dot.textContent = '•';

    dot.style.left = item[0];
    dot.style.top = item[1];
    dot.style.color = item[2];
    dot.style.fontSize = '12px';
    dot.style.animationDelay = (0.35 + index * 0.08) + 's';

    scene.appendChild(dot);
  });

  document.body.appendChild(scene);

  setTimeout(() => {
    scene.classList.add('rbs-veterans-scene--fade');
  }, 2100);

  setTimeout(() => {
    scene.remove();
  }, 2750);
});